//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
let d=[[[0,"AllowDeleteMembers",1,0]],[[[],"GetFeatureGroupType",{R_:{type:''}},0,0],[["type"],"SetFeatureGroupType",{},1,0],[[],"RemoveAllMembers",{},0,0],[["members","reorderTimestamp"],"NewRemoveMembers",{},2,0],[["members","reorderTimestamp"],"NewAddMembers",{},2,1],[["members","reorderTimestamp","updateRelocatedFeatures"],"AddMembersWithRelocation",{},3,0],[["numMembers","members"],"GetMembers",{},0,0],[[],"MakeTimestampsConsecutive",{},0,1],[["updateRelocatedFeatures"],"MakeTimestampsSequential",{},1,0],[[],"ConvertToTimestampedFeatureGroup",{},0,0],[[],"ConvertToFloatingFeatureGroup",{},0,0]],[]];
SPLM.Features.FeatureGroup = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FeatureGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FeatureGroup.Type = Object.freeze({
    "NonEmbeddFeatureGroup" : "NonEmbeddFeatureGroup", "EmbeddFeatureGroup" : "EmbeddFeatureGroup"});

export default SPLM;